module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up-basics"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/global/logo.svg")
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-one active",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Log In")])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "long-form"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("First name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.firstname),
      expression: "$parent.firstname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. John",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.firstname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Last name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.surname),
      expression: "$parent.surname",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Smith",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.surname = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where do you work?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.organisation),
      expression: "$parent.organisation",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Example PLC",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.organisation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.organisation = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("Sector:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$parent.sector),
      expression: "$parent.sector"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$parent.sector = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _c('option', [_vm._v("NGO")]), _vm._v(" "), _c('option', [_vm._v("Students")]), _vm._v(" "), _c('option', [_vm._v("Academia")]), _vm._v(" "), _c('option', [_vm._v("Researchers")]), _vm._v(" "), _c('option', [_vm._v("Private Sector")]), _vm._v(" "), _c('option', [_vm._v("Government")]), _vm._v(" "), _c('option', [_vm._v("Development Workers")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "shift-3 col-3"
  }, [_c('label', [_vm._v("Where are you currently based?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.location),
      expression: "$parent.location",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. London"
    },
    domProps: {
      "value": (_vm.$parent.location)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.location = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-3"
  }, [_c('label', [_vm._v("What's your job title?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.jobtitle),
      expression: "$parent.jobtitle",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "text",
      "placeholder": "eg. Operations Manager",
      "required": ""
    },
    domProps: {
      "value": (_vm.$parent.jobtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$parent.jobtitle = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])])]), _vm._v(" "), _c('section', {
    staticClass: "sign-up-navigation"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('a', {
    staticClass: "link-back",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.stepBack($event)
      }
    }
  }, [_vm._v("Change Password")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-big bg-four register",
    class: {
      active: _vm.formComplete
    },
    attrs: {
      "id": "next"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.register($event)
      }
    }
  }, [_vm._v("Next")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "instructions"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('h2', [_vm._v("Tell us a bit more about you, your work and areas of interest.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f550b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/register/Register-Step-3.vue
// module id = 687
// module chunks = 1